<template>
  <button @click="open">
    <slot />

    <dpc-popup-share
      :is-open="isPopupOpen"
      @close="close"
      :id="`popup-share-${id}`"
    >
      <h1 class="popup-share__heading" id="share-label">
        <a-label path="share" is-visible />
      </h1>
      <div class="popup-share__context">
        <p>
          <a-label path="recommend" is-visible /> „<strong>{{ title }}</strong
          >"
        </p>
        <ul class="popup-share__list">
          <li class="popup-share__item">
            <a
              :href="`mailto:?body=${link}`"
              class="popup-share__link circle-button circle-button--inverted"
            >
              <dpc-icon
                icon="mail"
                class="circle-button__icon"
                custom-label="Mail"
              ></dpc-icon>
            </a>
          </li>
          <li class="popup-share__item">
            <a
              :href="`//wa.me/?text=${link}`"
              class="popup-share__link circle-button circle-button--inverted"
            >
              <dpc-icon
                icon="whatsapp"
                class="circle-button__icon"
                custom-label="Whatsapp"
              ></dpc-icon>
            </a>
          </li>
          <li class="popup-share__item">
            <a
              :href="`//twitter.com/intent/tweet?text=${link}`"
              class="popup-share__link circle-button circle-button--inverted"
            >
              <dpc-icon
                icon="x_twitter"
                class="circle-button__icon"
                custom-label="X"
              ></dpc-icon>
            </a>
          </li>
          <li class="popup-share__item">
            <a
              :href="`//facebook.com/sharer/sharer.php?u=${link}`"
              class="popup-share__link circle-button circle-button--inverted"
            >
              <dpc-icon
                icon="facebook_outlines"
                class="circle-button__icon"
                custom-label="Facebook"
              ></dpc-icon>
            </a>
          </li>
          <li class="popup-share__item">
            <a
              :href="`//t.me/share/url?url=${link}`"
              class="popup-share__link circle-button circle-button--inverted"
            >
              <dpc-icon
                icon="telegram"
                class="circle-button__icon"
                custom-label="Telegram"
              ></dpc-icon>
            </a>
          </li>

          <!-- <li class="popup-share__item">
                      <a
                        :href="`instagram://sharesheet?text=${link}`"
                        class="popup-share__link circle-button circle-button--inverted"
                      >
                        <dpc-icon
                          icon="instagram_outlines"
                          class="circle-button__icon"
                          custom-label="Instagram"
                        ></dpc-icon>
                      </a>
                    </li> -->
        </ul>

        <dpc-link-copier
          class="link-copier--inverted"
          :url="link"
        ></dpc-link-copier>
      </div>
    </dpc-popup-share>
  </button>
</template>

<script setup>
import { uuid } from 'vue-uuid';
import { readonly, ref, toRefs } from 'vue';
import { isMobile } from 'detect-if-mobile';

const id = readonly(ref(uuid.v1()));

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
});

const { title, link } = toRefs(props);
const isPopupOpen = ref(false);

const open = () => {
  const shareData = {
    title: title.value,
    url: link.value,
  };

  if (isMobile() && navigator.canShare && navigator.canShare(shareData)) {
    navigator.share(shareData);
    return;
  }

  isPopupOpen.value = true;
};

const close = () => {
  isPopupOpen.value = false;
};
</script>
